enum MessageThreadType {
    Enterprise = 'Enterprise',
    Private = 'Private',
}

export default MessageThreadType;
